import { Component, Inject, OnInit } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { FECRAdditionalObsVM } from '../FECRDashboard/fecr-search-panel/fecr-search-panel.model';
import { FrontEndComponetService } from '../front-end-componet.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-fecr-add-new-prepost-shipment-observation',
  templateUrl: './fecr-add-new-prepost-shipment-observation.component.html',
  styleUrls: ['./fecr-add-new-prepost-shipment-observation.component.scss']
})
export class FecrAddNewPrepostShipmentObservationComponent implements OnInit {

  additionalObservationList:FECRAdditionalObsVM;
  Title:string;
  InspectionTypeId:number;
  Active:boolean=true;
  Id:number;
  ImplementTypeId:number;
  isEditing= false;
  isInspectionEdit:boolean=false;
  InspectionId:number=0;
  ObsId:number = 0;
  constructor( public dialogRef: MatDialogRef<FecrAddNewPrepostShipmentObservationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _notification: NotificationsService,
    private _fecrService: FrontEndComponetService,
    ) { }

  ngOnInit() {
      this.isEditing = this.data.isEditing;
      this.isInspectionEdit = this.data.isInspectionEdit;
      this.InspectionId = this.data.InspectionId;


      
    this.ImplementTypeId=this.data.ImplementTypeId;
    if(this.isEditing==true){
      this.Title = this.data.Title
      this.InspectionTypeId = this.data.InspectionTypeId
      this.Active = this.data.Active;
      this.Id = this.data.Id;
      this.ObsId =this.data.ObsId

    }
  }

  onNoClick() {
    this.dialogRef.close(false);
  }

 

  ValidationCheck(){
    if(this.Title=='' || this.Title==null|| this.InspectionTypeId==null){
     return  this._notification.error("Please fill in all the required fields.")
    }else{
      this.SaveObservation();
    }
  }

  SaveObservation(){
    let model =  new FECRAdditionalObsVM();
    model.Title = this.Title;
    model.Active=this.Active;
    model.InspectionTypeId=this.InspectionTypeId;
    model.Id = this.isEditing==true?this.Id:0;
    model.ImplementTypeId =this.ImplementTypeId;
    this._fecrService.SaveFECRAdditionalObservation(model).subscribe(res=>{
      if(res.m_Item1==true){
        this.dialogRef.close(true);
      }else{
        
      }
    })
  }

  InspectionSaveObservation(){
    let model =  new FECRAdditionalObsVM();
    model.Title = this.Title;
    model.Active=this.Active;
    model.InspectionTypeId=this.InspectionTypeId;
    model.Id = this.InspectionId
    model.ImplementTypeId =this.ImplementTypeId;
    model.ObsId=this.ObsId;
    this._fecrService.SaveFECRInspectionAdditionalObservation(model).subscribe(res=>{
      if(res.m_Item1==true){
        this.dialogRef.close(true);
      }else{
        
      }
    })
  }

}
